module.exports = __webpack_public_path__ + "img/repeate-music.754e2650.svg";